import * as ambassadorWixEcomDiscountsV1DiscountRule from './ecom-discounts-v1-discount-rule-discount-rules.http.js';
import * as ambassadorWixEcomDiscountsV1DiscountRuleTypes from './ecom-discounts-v1-discount-rule-discount-rules.types.js';
import * as ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes from './ecom-discounts-v1-discount-rule-discount-rules.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDiscountRule(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.CreateDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.CreateDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.CreateDiscountRuleResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.CreateDiscountRuleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.createDiscountRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/discount-rules',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDiscountRule(): __PublicMethodMetaInfo<
  'GET',
  { discountRuleId: string },
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.GetDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.GetDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.GetDiscountRuleResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.GetDiscountRuleResponse
> {
  const payload = { discountRuleId: ':discountRuleId' } as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.getDiscountRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/discount-rules/{discountRuleId}',
    pathParams: { discountRuleId: 'discountRuleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDiscountRule(): __PublicMethodMetaInfo<
  'PATCH',
  { discountRuleId: string },
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.UpdateDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.UpdateDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.UpdateDiscountRuleResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.UpdateDiscountRuleResponse
> {
  const payload = { discountRule: { id: ':discountRuleId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.updateDiscountRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/discount-rules/{discountRule.id}',
    pathParams: { discountRuleId: 'discountRuleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDiscountRule(): __PublicMethodMetaInfo<
  'DELETE',
  { discountRuleId: string },
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.DeleteDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.DeleteDiscountRuleRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.DeleteDiscountRuleResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.DeleteDiscountRuleResponse
> {
  const payload = { discountRuleId: ':discountRuleId' } as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.deleteDiscountRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/discount-rules/{discountRuleId}',
    pathParams: { discountRuleId: 'discountRuleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDiscountRules(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.QueryDiscountRulesRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.QueryDiscountRulesRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.QueryDiscountRulesResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.QueryDiscountRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.queryDiscountRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/discount-rules/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDiscountRuleTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.BulkUpdateDiscountRuleTagsRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.BulkUpdateDiscountRuleTagsRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.BulkUpdateDiscountRuleTagsResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.BulkUpdateDiscountRuleTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.bulkUpdateDiscountRuleTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/discount-rules/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDiscountRuleTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.BulkUpdateDiscountRuleTagsByFilterRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.BulkUpdateDiscountRuleTagsByFilterRequest,
  ambassadorWixEcomDiscountsV1DiscountRuleUniversalTypes.BulkUpdateDiscountRuleTagsByFilterResponse,
  ambassadorWixEcomDiscountsV1DiscountRuleTypes.BulkUpdateDiscountRuleTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomDiscountsV1DiscountRule.bulkUpdateDiscountRuleTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/discount-rules/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DiscountRule as DiscountRuleOriginal,
  DiscountTrigger as DiscountTriggerOriginal,
  DiscountTriggerTriggerOneOf as DiscountTriggerTriggerOneOfOriginal,
  Scope as ScopeOriginal,
  ScopeScopeItemsOneOf as ScopeScopeItemsOneOfOriginal,
  ScopeType as ScopeTypeOriginal,
  ScopeTypeWithLiterals as ScopeTypeWithLiteralsOriginal,
  CatalogItemFilter as CatalogItemFilterOriginal,
  CustomFilter as CustomFilterOriginal,
  And as AndOriginal,
  Or as OrOriginal,
  Custom as CustomOriginal,
  SubtotalRange as SubtotalRangeOriginal,
  ItemQuantityRange as ItemQuantityRangeOriginal,
  CustomerEligibility as CustomerEligibilityOriginal,
  CustomerEligibilityOptionsOneOf as CustomerEligibilityOptionsOneOfOriginal,
  EligibilityType as EligibilityTypeOriginal,
  EligibilityTypeWithLiterals as EligibilityTypeWithLiteralsOriginal,
  ContactSegments as ContactSegmentsOriginal,
  ContactTags as ContactTagsOriginal,
  TagReference as TagReferenceOriginal,
  IndividualMembers as IndividualMembersOriginal,
  TriggerType as TriggerTypeOriginal,
  TriggerTypeWithLiterals as TriggerTypeWithLiteralsOriginal,
  ActiveTimeInfo as ActiveTimeInfoOriginal,
  Recurrence as RecurrenceOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  TimeOfDay as TimeOfDayOriginal,
  TimeWindow as TimeWindowOriginal,
  WeeklySchedule as WeeklyScheduleOriginal,
  Discounts as DiscountsOriginal,
  Discount as DiscountOriginal,
  DiscountDiscountOneOf as DiscountDiscountOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  SpecificItemsInfo as SpecificItemsInfoOriginal,
  QuantityBased as QuantityBasedOriginal,
  DiscountConfig as DiscountConfigOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  BuyXGetYInfo as BuyXGetYInfoOriginal,
  CustomerBuy as CustomerBuyOriginal,
  CustomerBuyConditionOneOf as CustomerBuyConditionOneOfOriginal,
  CustomerGet as CustomerGetOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  DiscountSettings as DiscountSettingsOriginal,
  AppliedSubjectType as AppliedSubjectTypeOriginal,
  AppliedSubjectTypeWithLiterals as AppliedSubjectTypeWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  TagsModified as TagsModifiedOriginal,
  CreateDiscountRuleRequest as CreateDiscountRuleRequestOriginal,
  CreateDiscountRuleResponse as CreateDiscountRuleResponseOriginal,
  GetDiscountRuleRequest as GetDiscountRuleRequestOriginal,
  GetDiscountRuleResponse as GetDiscountRuleResponseOriginal,
  UpdateDiscountRuleRequest as UpdateDiscountRuleRequestOriginal,
  UpdateDiscountRuleResponse as UpdateDiscountRuleResponseOriginal,
  DeleteDiscountRuleRequest as DeleteDiscountRuleRequestOriginal,
  DeleteDiscountRuleResponse as DeleteDiscountRuleResponseOriginal,
  QueryDiscountRulesRequest as QueryDiscountRulesRequestOriginal,
  PlatformQuery as PlatformQueryOriginal,
  PlatformQueryPagingMethodOneOf as PlatformQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  PlatformPaging as PlatformPagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryDiscountRulesResponse as QueryDiscountRulesResponseOriginal,
  PlatformPagingMetadata as PlatformPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  GetAppliedDiscountsRequest as GetAppliedDiscountsRequestOriginal,
  LineItem as LineItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  BuyerInfo as BuyerInfoOriginal,
  ShippingInfo as ShippingInfoOriginal,
  Address as AddressOriginal,
  GetAppliedDiscountsResponse as GetAppliedDiscountsResponseOriginal,
  AppliedDiscount as AppliedDiscountOriginal,
  AppliedDiscountRule as AppliedDiscountRuleOriginal,
  DiscountRuleName as DiscountRuleNameOriginal,
  MultiCurrencyPrice as MultiCurrencyPriceOriginal,
  ItemCombination as ItemCombinationOriginal,
  ItemCombinationLineItem as ItemCombinationLineItemOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  DiscountRuleUsageLimitReached as DiscountRuleUsageLimitReachedOriginal,
  BulkUpdateDiscountRuleTagsRequest as BulkUpdateDiscountRuleTagsRequestOriginal,
  BulkUpdateDiscountRuleTagsResponse as BulkUpdateDiscountRuleTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateDiscountRuleTagsResult as BulkUpdateDiscountRuleTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateDiscountRuleTagsByFilterRequest as BulkUpdateDiscountRuleTagsByFilterRequestOriginal,
  BulkUpdateDiscountRuleTagsByFilterResponse as BulkUpdateDiscountRuleTagsByFilterResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateDiscountRuleApplicationErrors as CreateDiscountRuleApplicationErrorsOriginal,
  CreateDiscountRuleValidationErrors as CreateDiscountRuleValidationErrorsOriginal,
  BulkUpdateDiscountRuleTagsApplicationErrors as BulkUpdateDiscountRuleTagsApplicationErrorsOriginal,
  BulkUpdateDiscountRuleTagsByFilterApplicationErrors as BulkUpdateDiscountRuleTagsByFilterApplicationErrorsOriginal,
} from './ecom-discounts-v1-discount-rule-discount-rules.types.js';
